// Some customizations for LMV buttons
export default (button, rightTooltip) => {
    //Default LMV buttons are too large for the minimap
    button.container.style.width = "20px";
    button.container.style.height = "20px";
    button.container.style.padding = "3px 8px";

    // The icon class adds a top-padding of 3 which broke the centering of the button.
    button.icon.classList.remove("adsk-button-icon");

    // Show tooltips left of the buttons and vertically centered.
    // The default behavior would place the tooltip outside of canvas and minimap,
    // so that they would not be visible.
    button.setToolTip(""); // Init tooltip element
    const tts = button._toolTipElement.style;
    tts.bottom = "0px";
    tts.top = "auto";
    tts.height = "fit-content";

    if (rightTooltip) {
        tts.left = "auto";
        tts.right = "130%";
    } else {
        tts.top = "40px";
    }

    tts.zIndex = 3;
};
